import { FBPage } from 'components/FbUI/Page/FBPage'
import { Outlet, useLocation } from 'react-router-dom'
import {
  FBPageEyebrow,
  FBPageHeader,
  FBPageTitle,
  FBPageTitleRow,
} from 'components/FbUI/Page/styles'
import { PiGear } from 'react-icons/pi'

import { useMemo } from 'react'
import { Sparkles } from 'lucide-react'

const GROUP_TITLES: Record<string, React.ReactNode> = {
  company: 'Company',
  team: 'Team',
  platform: 'Platform',
  data: 'Data',
  notifications: 'Notifications',
  misc: 'Misc Settings',
  automations: 'Automations',
  outreach: 'Outreach',
  'email-integration': 'Email Integration',

  ai: (
    <span className="inline-flex items-center gap-1.5">
      <Sparkles size={20} />
      AI Agents
    </span>
  ),
}

export function SettingsLayout() {
  const location = useLocation()

  const group = useMemo(() => {
    const segments = location.pathname.split('/')
    return segments[2] ?? 'team'
  }, [location.pathname])

  const groupTitle = GROUP_TITLES[group] ?? 'Team'
  const isAI = group === 'ai'

  if (isAI) {
    // AI page uses noContainer + full-bleed layout like the deals detail page.
    // Left sidebar has gray bg, right side is white — no surrounding gray border.
    return (
      <FBPage innerPageClassName="!p-0 h-full" noContainer>
        <div className="flex flex-1 min-h-0 h-full overflow-hidden">
          <Outlet />
        </div>
      </FBPage>
    )
  }

  return (
    <FBPage
      innerPageClassName="h-full !bg-[#fefefe]"
      containerClassName="!bg-[#fefefe] !shadow-none"
    >
      <FBPageHeader className="!mb-6">
        <FBPageTitleRow>
          <div className="flex flex-col items-start">
            <FBPageEyebrow>
              <PiGear size={14} />
              Settings
            </FBPageEyebrow>
            <FBPageTitle className="!text-fg">{groupTitle}</FBPageTitle>
          </div>
        </FBPageTitleRow>
      </FBPageHeader>

      <div className="flex gap-0 flex-1 min-h-0 h-full">
        <Outlet />
      </div>
    </FBPage>
  )
}
